/**
 * Класс для управления progress-bar
 */
class ProgressBar {
	constructor(SliderController) {
		this.mainSliderController = SliderController;
		this.progressBarConfig = {};

		this.progressBarContainer = $('#mainapge-slider-progress-bar');
		this.progressBarSections = this.progressBarContainer.find('[data-section-id]');
		this.progressBarTriggers = this.progressBarContainer.find('[data-section-trigger-id]');
		this.progressBarLines = this.progressBarContainer.find('[data-section-progress-bar-id]');

		this.triggerActiveClass = 'is-active';
		this.completedClass = 'is-completed';

		this.buildConfig();
		this.initTriggersClickEvent();
	}

	/**
	 * Посмотроение конфига секций
	 */
	buildConfig() {
		const $mainSliderItems = this.mainSliderController.getSliderItems();

		$mainSliderItems.each((i, slide) => {
			const $slide = $(slide);
			const slideID = $slide.attr('data-slide-id');

			switch (slideID) {
				//в первом слайдере песочные часы
				case '0':
					const hourglassSliderItemsCount = this.mainSliderController.hourglassController.getSliderItemsCount();

					this.progressBarConfig[`section-${slideID}`] = {
						sectionKeyID: `section-${slideID}`,
						sectionID: slideID,
						itemsCount: hourglassSliderItemsCount
					};

					break;
				case '1':
					const pieChartSectorsCount = this.mainSliderController.pieChartController.getSectorsCount();

					this.progressBarConfig[`section-${slideID}`] = {
						sectionKeyID: `section-${slideID}`,
						sectionID: slideID,
						itemsCount: pieChartSectorsCount
					};

					break;
				case '2':
					const projectsSliderItemsCount = this.mainSliderController.projectsSliderController.getSliderItemsCount();

					this.progressBarConfig[`section-${slideID}`] = {
						sectionKeyID: `section-${slideID}`,
						sectionID: slideID,
						itemsCount: projectsSliderItemsCount
					};

					break;
				case '3':
					this.progressBarConfig[`section-${slideID}`] = {
						sectionKeyID: `section-${slideID}`,
						sectionID: slideID,
						itemsCount: 1
					};

					break;
			}
		});
	}

	initTriggersClickEvent() {
		this.progressBarTriggers.each((i, trigger) => {
			const $trigger = $(trigger);

			$trigger.on('click touch', (e) => {
				const slideID = $trigger.attr('data-section-trigger-id');
				this.mainSliderController.mainSliderInstance.slideTo(slideID);

				return false;
			});
		});
	}

	/**
	 * Внешний метод для заполнения секции на переданное количество делений
	 * @param sectionID
	 * @param fillProportion
	 */
	fillSection(sectionID = 0, fillProportion = 0) {
		this.clearProgressForAll();
		this.fillSectionRecursively(sectionID, fillProportion);
	}

	/**
	 * Рекурсивно заполняет секцию на переданное количество долей
	 * и всех предыдущие секции
	 * @param sectionID - id секции
	 * @param fillProportion - количество подсекция для заполнения
	 */
	fillSectionRecursively(sectionID = 0, fillProportion = 0) {
		//если секция существует в конфиге
		if (this.isExistSectionInConfig(sectionID)) {
			//берем секцию из конфига
			const configForSection = this.getConfigForSectionID(sectionID);
			const configForPreviousSection = this.getConfigForPreviousSection(sectionID);
			const sectionProgressBar = this.getProgressBarByID(sectionID);
			const sectionTrigger = this.getTriggerByID(sectionID);
			let barFillWidth = 0;

			if (configForPreviousSection) {
				this.fillSection(configForPreviousSection['sectionID'], configForPreviousSection['itemsCount']);
			}

			if (fillProportion) {
				if (fillProportion > configForSection['itemsCount']) {
					barFillWidth = 100;
					fillProportion = configForSection['itemsCount'];
				} else {
					barFillWidth = fillProportion / configForSection['itemsCount'] * 100;
				}
			}

			//если достигнуто последнее деление в последней секции
			if (configForSection['sectionID'] == String(this.progressBarSections.last().attr('data-section-id'))
				&& configForSection['itemsCount'] == fillProportion) {
				this.progressBarContainer.addClass(this.completedClass);
			} else {
				this.progressBarContainer.removeClass(this.completedClass);
			}

			sectionProgressBar.width(`${barFillWidth}%`);
			sectionTrigger.addClass(this.triggerActiveClass);
		}
	}

	/**
	 * Очистить весь progress-bar
	 */
	clearProgressForAll() {
		this.progressBarLines.width(0);
		this.progressBarTriggers.removeClass('is-active');
	}

	/**
	 * Существует ли секция в конфиге
	 * @param id
	 * @returns {boolean}
	 */
	isExistSectionInConfig(id) {
		return this.progressBarConfig[`section-${id}`] != undefined;
	}

	/**
	 * Взять секцию из конфига по ее ID
	 * @param id
	 * @returns {*}
	 */
	getConfigForSectionID(id) {
		return this.progressBarConfig[`section-${id}`];
	}

	getConfigForPreviousSection(id) {
		let numID = Number(id);
		let prevID = numID - 1;

		//если секция существует в конфиге
		if (this.isExistSectionInConfig(prevID)) {
			//возвращаем секцию из конфига
			return this.getConfigForSectionID(prevID);
		} else {
			return false;
		}
	}

	/**
	 * Возвращает секцию по ID
	 * @param id
	 */
	getSectionByID(id) {
		return this.progressBarSections.filter((key, item) => {
			return $(item).attr(`data-section-id`) == id;
		});
	}

	/**
	 * Возвращает триггер по ID
	 * @param id
	 */
	getTriggerByID(id) {
		return this.progressBarTriggers.filter((key, item) => {
			return $(item).attr(`data-section-trigger-id`) == id;
		});
	}

	/**
	 * Возвращает progressBar по ID
	 * @param id
	 */
	getProgressBarByID(id) {
		return this.progressBarLines.filter((key, item) => {
			return $(item).attr(`data-section-progress-bar-id`) == id;
		});
	}
}

module.exports = ProgressBar;



// WEBPACK FOOTER //
// ./temp/components/mainpage/classes/ProgressBar.js